import { ResultModel } from './result_model';

export const STATUS_OK = "OK";
export const STATUS_FAIL = "FAIL";

export class ResponseModel {
  // RESPONSE_STATUS_OK = "OK";
  // RESPONSE_STATUS_FAIL = "FAIL";
  /**
   *
   * @param Object response
   */

  // constructor(response) {
  //   this.result = null;
  //   this.error = response.data.error;
  //   this.message = response.data.message;
  //   this.data = response.data.data;
  //   this.status = response.data.status;
  //   if (this.status == RESPONSE_STATUS_OK) {
  //     this.result = new ResultModel(response.data.result);
  //   }
  //   else {
  //     this.result = new ResultModel([]);
  //   }
  // }

  constructor(response) {
    this.error = response.data.error;
    this.message = response.data.message;
    this.data = response.data.data;
    this.status = response.data.status;
    if (this.status == STATUS_OK) {
      this.result = new ResultModel(response.data.result);
    }
    else {
      this.result = new ResultModel([]);
    }
    // this.result = new ResultModel(response.data.result);
  }

}
